import React from 'react';
import PropTypes from 'prop-types';
import classes from "classnames";
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import 'react-datepicker/dist/react-datepicker.css';
import Input from '../../../../../components/Input/index';
import Textarea from '../../../../../components/Textarea/index';
import SearchBox from '../../../../../components/Map/SearchBox';
import UploadImages from '../UploadImages';
// import UploadVideo from '../UploadVideo';
import Map from '../../../../../components/Map/Map';

class Tmp3 extends React.Component {
  constructor(props) {
    super(props);
    this.handleAddress = this.handleAddress.bind(this);
    this.state = {
      cords: {lat: '', lng: ''},
      zoom: 8
    }
  }

  static propTypes = {
    // isPendingUploadVideo: PropTypes.bool,
    // blockType: PropTypes.string,
    title: PropTypes.string,
    minPersons: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]) ,
    maxPersons: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]) ,
    priceOnePerson: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]) ,
    description: PropTypes.string,
    images: PropTypes.array,
    imagesPreview: PropTypes.object,
    categoryId: PropTypes.number,
    address: PropTypes.string,
    lat: PropTypes.number,
    lng: PropTypes.number,
    // tourVideos: PropTypes.array,
    handleChange: PropTypes.func,
    handleNewImage: PropTypes.func,
    // handleNewVideo: PropTypes.func,
    handleAddress: PropTypes.func,
    categoriesOptions: PropTypes.array,
    // deleteVideo: PropTypes.func,
    // showPlayer: PropTypes.func,
    error: PropTypes.object
  };

  componentWillMount() {
    this.setState({cords: {lat: this.props.lat || '', lng: this.props.lng || ''}})
  }

  componentWillReceiveProps(next) {
    this.setState({cords: {lat: next.lat || '', lng: next.lng || ''}})
  }

  handleAddress(data) {
    this.props.handleAddress(data);
    this.setState({cords: {lat: data.lat, lng: data.lng}, zoom: 14});
  }

  render() {
    const {
      // isPendingUploadVideo,
      title,
      minPersons,
      maxPersons,
      priceOnePerson,
      description,
      images,
      imagesPreview,
      categoryId,
      address,
      // tourVideos,
      handleChange,
      handleNewImage,
      // handleNewVideo,
      categoriesOptions,
      // deleteVideo,
      // showPlayer,
      error,
      // blockType
    } = this.props;

    const {
      cords,
      zoom
    } = this.state;

    const styleClass = classes('create-tour__photos', {active: images.length > 0});

    return (
      <div className="create-tour__template create-tour__template-3">
        <Input
          className="create-tour__name"
          type="text"
          label="Tour name"
          placeholder="Tour name"
          value={title}
          name="title"
          error={error.title}
          onChange={handleChange}
        />
        <div className="input-block select-block create-tour__category">
          <span className="input-block__label">Category</span>
          <Select
            placeholder="Category"
            name="categoryId"
            value={categoryId}
            onChange={(e) => e && e.value ? handleChange({target: {name: 'categoryId', value: e.value}}) : null}
            clearable={false}
            options={categoriesOptions}
          />
        </div>
        <div className={styleClass}>
          <UploadImages
            images={images}
            error={error}
            onNewImages={handleNewImage}
          />
          {imagesPreview}
        </div>
        <div className="create-tour__group-block create-tour__group-block_first">
          <Textarea
            className="create-tour__textarea"
            label="Tour Description"
            placeholder="Tour Description"
            value={description}
            name="description"
            error={error.description}
            onChange={handleChange}
          />
          <div className="create-tour__map">
            <div className="create-tour__search input-block">
              <span className="create-tour__search-title">Address</span>
              <SearchBox
                onNewPlace={this.handleAddress}
                address={address}
              />
              {error.address ?
                <span className="error-block">{error.address}</span> : null
              }
            </div>
            <Map
              cords={cords}
              zoom={zoom}
            />
            <div className="create-tour__info-tour">
              <div className="create-tour__group-block">
                <Input
                  type="text"
                  label="Min People / tour"
                  placeholder="0"
                  value={minPersons}
                  name="minPersons"
                  error={error.minPersons}
                  onChange={handleChange}
                />
                <Input
                  type="text"
                  label="Max People / tour"
                  placeholder="0"
                  value={maxPersons}
                  name="maxPersons"
                  error={error.maxPersons}
                  onChange={handleChange}
                />
              </div>
              <Input
                className="price"
                type="text"
                label="Price"
                placeholder="0"
                value={priceOnePerson}
                name="priceOnePerson"
                error={error.priceOnePerson}
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Tmp3


// WEBPACK FOOTER //
// ./src/app/containers/Vendor/Tour/components/Templates/Tmp3.js